// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__133Cd","head":"Table_head__1CTg1","col":"Table_col__1tdep"};